import { Box, Button, styled } from '@mui/material'
import { toast } from 'react-toastify'
import { getThirdLoginUrl } from 'services/module/user/thirdPartyLogin'
import AppleLoginIcon from 'assets/images/svg/userCenter/apple-login.svg'
import GoogleLoginIcon from 'assets/images/svg/userCenter/google-login.svg'
import FacebookLoginIcon from 'assets/images/svg/userCenter/facebook-login.svg'
import { useLocation } from 'react-router-dom'
import { useMemo } from 'react'

const ThirdPartyLoginBox = styled(Box)`
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`

const CommonThirdLoginButton = styled(Button)`
  background-repeat: no-repeat;
  background-size: contain;
  min-width: 56px;
  height: 56px;
  box-sizing: border-box;
  padding: 0;
  border-radius: 28px;
  cursor: pointer;
`

const AppleButton = styled(CommonThirdLoginButton)`
  background-image: url(${AppleLoginIcon});
`

const GoogleButton = styled(CommonThirdLoginButton)`
  background-image: url(${GoogleLoginIcon});
  margin: 0 2rem;
`

const FacebookButton = styled(CommonThirdLoginButton)`
  background-image: url(${FacebookLoginIcon});
`

enum ThirdPartyLoginType {
  Apple = 'apple',
  Google = 'google',
  Facebook = 'facebook',
}

export default function ThirdPartyLogin({ type }: { type: string }) {
  const location = useLocation()
  const handleThirdPartyLogin = (type: ThirdPartyLoginType) => {
    getThirdLoginUrl(type).then(res => {
      if (res.code === 200) {
        if (res.data) {
          window.location.href = res.data
        }
      } else {
        toast.error(res.msg)
      }
    })
  }
  const checkHidden = useMemo(() => {
    const hiddenPagePathList = ['/referral']
    const mapHiddenList = hiddenPagePathList.some(path => location.pathname.indexOf(path) > -1)
    return !mapHiddenList
  }, [location.pathname])
  return (
    <>
      {checkHidden && (
        <ThirdPartyLoginBox>
          <AppleButton onClick={() => handleThirdPartyLogin(ThirdPartyLoginType.Apple)} />
          <GoogleButton onClick={() => handleThirdPartyLogin(ThirdPartyLoginType.Google)} />
          <FacebookButton onClick={() => handleThirdPartyLogin(ThirdPartyLoginType.Facebook)} />
        </ThirdPartyLoginBox>
      )}
    </>
  )
}
